import { ButtonHTMLAttributes } from 'react'
import { DisplayProps, MarginProps, PositionProps } from 'styled-system'

import { TestIdProps } from 'designSystem/types/propTypes'

import INTERNALxButton from 'designSystem/components/internal/elements/INTERNALxButton'
import { COLOR } from 'designSystem/foundations/constants/color'
import { FONT_SIZE } from 'designSystem/foundations/constants/fontSize'
import { FONT_WEIGHT } from 'designSystem/foundations/constants/fontWeight'
import { SIZE } from 'designSystem/foundations/constants/size'

type BaseProps = ButtonHTMLAttributes<HTMLButtonElement> &
  DisplayProps &
  MarginProps &
  PositionProps &
  TestIdProps

type Props = {
  isActive?: boolean
  testId?: string
  text?: number | string
} & BaseProps

export default function INTERNALxPaginationButton({
  isActive = false,
  name,
  testId,
  text,
  ...props
}: Props) {
  const selectState = isActive ? 'active' : 'inactive'
  const borderColor = isActive ? COLOR.neutral400 : COLOR.neutral300
  const buttonColor = isActive ? COLOR.content : COLOR.backdrop

  return (
    <INTERNALxButton
      {...props}
      backgroundColor={buttonColor}
      border={`1.4px solid ${borderColor}`}
      borderRadius={SIZE.s4}
      className={`button pagination ${selectState}`}
      color={COLOR.textButtonTertiary}
      fontSize={FONT_SIZE.xs}
      fontWeight={FONT_WEIGHT.semibold}
      height="2rem"
      minWidth="2rem"
      padding={SIZE.s4}
      testId={testId}
      textAlign="center"
    >
      {text}
    </INTERNALxButton>
  )
}
